import { createSlice } from '@reduxjs/toolkit';
import finalPropsSelectorFactory from 'react-redux/es/connect/selectorFactory';


const initialState = {
     loading: false,
        data: {},
        error: false,
    lastFetched: null,
};

// Try to load from localStorage
const saved = localStorage.getItem('clusters');
if (saved) {
    try {
        const parsed = JSON.parse(saved);
        initialState.data = parsed.data || {};
        initialState.lastFetched = parsed.lastFetched || null;
    } catch (err) {
        console.error('Error parsing localStorage tenant alarm cache:', err);
    }
}

export const ClusterSlice = createSlice({
    name:'ClusterSlice',
    initialState:initialState,
    reducers:{
        CLUSTER_FETCH_START:(state)=>{
            state.loading=true
        },
        CLUSTER_FETCH_SUCCESS:(state,action)=>{
                 state.loading=finalPropsSelectorFactory
            state.data=action.payload
             state.lastFetched = Date.now();

            // ✅ Save to localStorage
            localStorage.setItem('clusters', JSON.stringify({
                sites: action.payload.sites,
                lastFetched: Date.now()
            }));
        },
        CLUSTER_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const { CLUSTER_FETCH_START,CLUSTER_FETCH_SUCCESS,CLUSTER_FETCH_ERROR }=ClusterSlice.actions;
export default ClusterSlice.reducer;